import { render, staticRenderFns } from "./MapaCalorCadastros.vue?vue&type=template&id=8fb1018a&scoped=true&"
import script from "./MapaCalorCadastros.vue?vue&type=script&lang=js&"
export * from "./MapaCalorCadastros.vue?vue&type=script&lang=js&"
import style0 from "./MapaCalorCadastros.vue?vue&type=style&index=0&id=8fb1018a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8fb1018a",
  null
  
)

export default component.exports